module.exports = __webpack_public_path__ + "groupon.png?ae25599576e7b00deb9b324a5cb30ce4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/groupon.png
// module id = 17
// module chunks = 0